import { render, staticRenderFns } from "./AppAnnotationPart2.vue?vue&type=template&id=7fa8531e&scoped=true"
import script from "./AppAnnotationPart2.vue?vue&type=script&lang=ts"
export * from "./AppAnnotationPart2.vue?vue&type=script&lang=ts"
import style0 from "./AppAnnotationPart2.vue?vue&type=style&index=0&id=7fa8531e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa8531e",
  null
  
)

export default component.exports